
import BasicState from "src/libs/basic-view"
import "../assets/css/style.scss"
import LandingForm from "./landing/LandingForm"
import contextMethods from "./landing/useful/contextMethods"

export default class LandingView extends BasicState {
    props: any
    contextMethods: any = contextMethods()
    addRender = () => { 
        return <div className="d-flex w-100 m-0 position-relative">
            <LandingForm {...this.props} />  
        </div>
    }
}